import * as PIXI from 'pixi.js';
import { ObjectPool } from '~/Tools';
import ApplicationStore from '~/flux/stores/ApplicationStore';

const bitmapStyle = {
  fontName: 'BitmapCourierBoldDropshadow',
};

const textStyle = new PIXI.TextStyle({
  fontFamily: 'Courier New',
  fontWeight: 'bold',
  dropShadow: true,
  dropShadowDistance: 0.8,
  dropShadowAngle: (7.5 * Math.PI) / 6,
  dropShadowColor: 0xffffff,
});

let _bitmapTextPool;
let _textPool;
ApplicationStore.once(ApplicationStore.ASSETS_LOADED, () => {
  _bitmapTextPool = new ObjectPool(
    // create func
    () => {
      const txt = new PIXI.BitmapText('', bitmapStyle);
      txt.anchor = { x: 0.5, y: 0.1 };
      return txt;
    },

    // reset func
    (txt) => {
      gsap.killTweensOf(txt);
      txt.parent?.removeChild(txt);
    },

    // starting num
    50
  );

  _textPool = new ObjectPool(
    // create func
    () => {
      const txt = new PIXI.Text('', textStyle);
      txt.anchor = { x: 0.5, y: 0.1 };
      return txt;
    },

    // reset func
    (txt) => {
      gsap.killTweensOf(txt);
      txt.parent?.removeChild(txt);
    },

    // starting num
    20
  );
});

const DURATION_SECS = 0.82;

const FloatingTextImage = function (str, txtSize, txtColor, useBitmapText = true) {
  PIXI.Container.call(this);

  const pool = useBitmapText ? _bitmapTextPool : _textPool;

  this.dispose = (txtObject) => {
    TweenMax.killTweensOf(this);
    const objToPut = txtObject || this.txtObject;
    objToPut && pool.put(objToPut);
    this.txtObject = null;
    DT_CANVAS_GLOBALS.poolSafeDestroy(this, { children: true });
  };

  this.anchor = { x: 0.5, y: 1 };

  this.init = () => {
    const txt = pool.get();
    this.txtObject = txt;
    txt.text = str;
    if (useBitmapText) {
      txt.fontSize = txtSize;
      txt.tint = txtColor;
    } else {
      txt.style.fontSize = txtSize;
      txt.style.fill = txtColor;
    }
    this.addChild(txt);

    TweenMax.to(this, DURATION_SECS, {
      x: this.x - 12 + Math.random() * 15,
      y: this.y - 21 - Math.random() * 8,
      ease: Quad.easeOut,
    });
    this.parent &&
      TweenMax.to(this, 0.1, {
        angle: -30 + Math.random() * 60,
        onComplete: () => {
          this.parent &&
            TweenMax.to(this, DURATION_SECS - 0.4, {
              angle: -12 + Math.random() * 24,
              ease: Quad.easeOut,
            });
        },
      });
    TweenMax.to(this, DURATION_SECS * 1.01, {
      // avoid race condition with dispose() & other tweens
      alpha: 0,
      ease: Expo.easeIn,
      onComplete: this.dispose,
      onCompleteParams: [txt],
    });

    this.pivot = { x: 0.5, y: 1 };

    if (str.endsWith('!')) {
      TweenMax.from(this.scale, 0.65, { x: 0, y: 0, ease: Bounce.easeOut });
    } else {
      TweenMax.from(this.scale, 0.1, { x: 0, y: 0 });
    }
  };
};
FloatingTextImage.prototype = Object.create(PIXI.Container.prototype);
FloatingTextImage.prototype.constructor = FloatingTextImage;
export default FloatingTextImage;
